<template>
  <comBox :bder="true" v-infinite-scroll="load" infinite-scroll-distance="20" style="background:white">
    <template v-slot:name>
       <div class="searchPro">
         <i class="el-icon-search"></i>
         <input type="text" :placeholder="searchText" @input="searchWord" v-model="word"/>
       </div>
    </template>
    <template v-slot:content v-if="ProjectList">
      <!-- 公司信息 -->
      <div class="company" v-for="(Project, index) in ProjectList" :key="index"  @click="$emit('clickProDet', Project.id, Project.city)">
        <div class="company-logo">
          <img :src="Project.image" v-if="Project.image" />
          <img src="../../assets/logo.png" v-else/>
        </div>
        <div class="company-info">
          <div class="company-name"><h3 class="ellipsis" style="width:1.5rem;textAlign:left">{{Project.name}}</h3><span class="project-type">{{$store.state.module1.isChina?'室内项目':'indoor'}}</span></div>
          <p class="ellipsis company-address"><i class="el-icon-location"></i>{{Project.address}}</p>
          <div class="company-dev-info">
            <div>
              <h5 v-if="Project.areaNum">{{Project.areaNum}}</h5>
              <h5 v-else>{{Project.dev_num}}</h5>
              <h6><slot name="glass">{{$store.state.module1.isChina?'项目场所':'place'}}</slot></h6>
            </div>
            <div>
              <h5 v-if="Project.dev_detail">{{Project.dev_detail.allNum}}</h5>
              <h6>{{$store.state.module1.isChina?'设备点位':'all'}}</h6>
            </div>
            <div>
              <h5 v-if="Project.dev_detail">{{Project.dev_detail.online}}</h5>
              <h6>{{$store.state.module1.isChina?'在线设备':'online'}}</h6>
            </div>
          </div>
        </div>
      </div>
      <!-- 公司信息 -->
    </template>
  </comBox>
</template>

<script>
import comBox from '../comBox/comBox.vue'
export default {
  name: 'Project',
  props: ['Projects', 'searchText', 'user'],
  components: {
    comBox
  },
  data () {
    return {
      word: '',
      ProjectList: null
    }
  },
  watch: {
    Projects () {
      this.$nextTick(() => {
        this.ProjectList = this.Projects
      })
    }
  },
  methods: {
    searchWord () {
      this.ProjectList = this.Projects.filter(item => {
        return item.name.indexOf(this.word) !== -1
      })
    },
    load () {
      this.$emit('loa')
    }
  }
}
</script>

<style scoped>
.searchPro{
  padding:0 0 0.2rem 0rem;
}
.searchPro input{
  padding: 0 0.1rem;
}
.company{
  padding:0.16rem 0;
  border-bottom:1px solid rgba(97,97,97,0.05);
  display:flex;
  cursor:pointer;
  align-items:center;
}
.company-logo{
  min-width:0.86rem;
  height:1.2rem;
  margin-right:0.16rem;
}
.company-logo img{
  height:100%;
}
.company-info{
  height:1.2rem;
  display:flex;
  flex-direction:column;
  justify-content:space-around;
}
.company-name, .company-dev-info{
  display:flex;
   align-items:center;
   justify-content:space-between;
}
.company-address{
width:2.45rem;
opacity: 0.8;
font-size: 0.14rem;
font-weight: 400;
text-align: left;
color: #1d2d4e;
}
.project-type{
  padding:0.03rem 0.09rem;
  font-size:0.12rem;
  background: #dbf3ff;
  border-radius: 0.06rem;
  color: #5ec6ff;
}
</style>
